import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ledgerUSBVendorId } from "@ledgerhq/devices";
var ledgerDevices = [{
  vendorId: ledgerUSBVendorId
}];
export function requestLedgerDevice() {
  return _requestLedgerDevice.apply(this, arguments);
}

function _requestLedgerDevice() {
  _requestLedgerDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var device;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return navigator.usb.requestDevice({
              filters: ledgerDevices
            });

          case 2:
            device = _context.sent;
            return _context.abrupt("return", device);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _requestLedgerDevice.apply(this, arguments);
}

export function getLedgerDevices() {
  return _getLedgerDevices.apply(this, arguments);
}

function _getLedgerDevices() {
  _getLedgerDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var devices;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return navigator.usb.getDevices();

          case 2:
            devices = _context2.sent;
            return _context2.abrupt("return", devices.filter(function (d) {
              return d.vendorId === ledgerUSBVendorId;
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getLedgerDevices.apply(this, arguments);
}

export function getFirstLedgerDevice() {
  return _getFirstLedgerDevice.apply(this, arguments);
}

function _getFirstLedgerDevice() {
  _getFirstLedgerDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var existingDevices;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getLedgerDevices();

          case 2:
            existingDevices = _context3.sent;

            if (!(existingDevices.length > 0)) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", existingDevices[0]);

          case 5:
            return _context3.abrupt("return", requestLedgerDevice());

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getFirstLedgerDevice.apply(this, arguments);
}

export var isSupported = function isSupported() {
  return Promise.resolve(!!navigator && // $FlowFixMe
  !!navigator.usb && typeof navigator.usb.getDevices === "function");
};